import React, { useMemo } from 'react';

import styled from 'styled-components';

import { Archive } from '@styled-icons/fa-solid';

import * as colors from '../../api/style';

import { Track } from '../../api';
import { TextBold12 } from './Text';

type StatusProps = Partial<Pick<Track, 'status'>>;

const TrackStatus = (props: StatusProps) => {
  const { status } = props;

  const Icon = useMemo(() => {
    if (status === 'archived') {
      return Archive;
    }

    return null;
  }, [status]);

  const label = useMemo(() => {
    if (status === 'archived') {
      return 'Archived';
    }

    if (status === 'declined') {
      return 'Declined';
    }

    return 'Active';
  }, [status]);

  if (!label) {
    return null;
  }

  return (
    <StatusContainer {...props}>
      {Icon && <Icon size={14} />}
      <TextBold12>{label}</TextBold12>
    </StatusContainer>
  );
};

export default TrackStatus;

const StatusContainer = styled.div<StatusProps>`
  margin: 0 !important;
  color: ${(props) => {
    if (props.status === 'archived') {
      return colors.error_new;
    }

    if (props.status === 'declined') {
      return colors.warning_new;
    }

    return colors.success_new;
  }};
  svg {
    margin-right: 6px;
  }
  ${TextBold12} {
    text-transform: uppercase;
  }
`;
